import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';

export const Navbar = ({ onNavigate }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const winH = window.innerHeight;
      const docH = document.body.scrollHeight;
      const pastHero = scrollY > winH * 0.75;
      const nearBottom = scrollY + winH > docH - winH * 0.6;
      setVisible(pastHero && !nearBottom);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      data-testid="nav-bar"
      className={cn(
        'fixed top-0 left-0 right-0 z-50 transition-all duration-500',
        visible
          ? 'opacity-100 translate-y-0 bg-[#0a1628]/80 backdrop-blur-[14px] border-b border-white/10 shadow-[0_10px_30px_rgba(0,0,0,0.35)]'
          : 'opacity-0 -translate-y-2 pointer-events-none bg-transparent'
      )}
    >
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center h-24 lg:h-28 gap-6">
          {/* PMI logo */}
          <img
            src="/pmi-logo.png"
            alt="Philip Morris International"
            className="h-14 lg:h-16 w-auto object-contain brightness-0 invert opacity-80"
          />

          <div className="w-px h-10 bg-white/20 flex-shrink-0" />

          {/* Wibe logo */}
          <button
            onClick={() => onNavigate(0)}
            className="flex items-center group"
            data-testid="nav-logo"
          >
            <img
              src="/wibe-logo.png"
              alt="Wibe Solutions"
              className="h-24 lg:h-28 w-auto"
            />
          </button>
        </div>
      </div>
    </nav>
  );
};
